<template>
  <div class="payment-result" v-if="payDetail">
    <div class="payment-result__icon" :class="statusClass"></div>
    <div class="payment-result__title">{{ title }}</div>
    <div class="payment-result__title-sub">{{ titleSub }}</div>
    <div class="payment-result__info" v-if="isSuccess">
      <div class="payment-result__info-title">{{ $t('payment.paymentDetails') }}</div>
      <div class="line-bottom mg-t-20"></div>
      <div class="payment-result__info-item">
        <div class="l">{{ $t('payment.orderNumber') }}</div>
        <div class="r">{{ orderId }}</div>
      </div>
      <div class="payment-result__info-item">
        <div class="l">{{ $t('payment.paymentTime') }}</div>
        <div class="r">{{ payDetail.successTime | paymentResultDateTimeFormat }}</div>
      </div>
      <div class="line-bottom mg-t-20"></div>
      <div class="payment-result__info-item" v-for="value in payDetail.bills">
        <div class="l">{{ $t(PAYMENT_BILLS_I18N[value.billType]) }}</div>
        <div class="r">{{ priceUint }}{{ value.amount | numberFormat }}</div>
      </div>
      <div class="payment-result__info-item" v-if="payDetail.amount">
        <div class="l">{{ $t('payment.total') }}</div>
        <div class="r org">{{ priceUint }}{{ payDetail.amount | numberFormat }}</div>
      </div>
    </div>
    <div class="payment-result__footer">
      <div class="btn-primary" @click="handlerClick(1)">{{ btnText.btn1 }}</div>
      <div class="btn-primary bt-white mg-t-30" @click="handlerClick(2)">{{ btnText.btn2 }}</div>
    </div>
  </div>
</template>

<script>

import { queryPaymentInfo } from '@/api/payment';
import { PAYMENT_STATUS, PAYMENT_BILLS_I18N } from '@/common/constants';
export default {
  name: 'PaymentResult',
  data() {
    return {
      payType: '',
      orderId: '',
      payDetail: null,
      PAYMENT_BILLS_I18N
    }
  },
  computed: {
    status() {
      return this.payDetail?.state || '';
    },
    priceUint() {
      return this.$t('priceUnit');
    },
    title() {
      return {
        SUCCESS: this.$t('payment.success'),
        FAILED: this.$t('payment.failed'),
        TIMEOUT: this.$t('payment.timeout'),
      }[this.status] || ''
    },
    titleSub() {
      return {
        SUCCESS: this.$t('payment.successSub'),
        FAILED: this.$t('payment.failedSub'),
        TIMEOUT: this.$t('payment.timeoutSub'),
      }[this.status] || ''
    },

    statusClass() {
      return {
        SUCCESS: 'success',
        FAILED: 'failed',
        CLOSED: 'timeout',
      }[this.status] || ''
    },
    isSuccess() {
      return this.status === PAYMENT_STATUS.SUCCESS;
    },
    btnText() {
      if (this.isSuccess) {
        return {
          btn1: this.$t('payment.btnGoHome'),
          btn2: this.$t('payment.btnOrderList')
        }
      } else {
        return {
          btn1: this.$t('payment.btnReorder'),
          btn2: this.$t('payment.btnGoHome')
        }
      }
    }
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
    this.payType = this.$route.query.payType || '';
    this.initData();
  },

  methods: {
    initData() {
      queryPaymentInfo({
        orderId: this.orderId,
      }).then(res => {
        if (res.code === 'Success') {
          if (PAYMENT_STATUS.SUCCESS !== res.data?.state) {
            if (payType === 'repay') {
              this.$router.replace(`/rentalplan/detail?orderId=${this.orderId}`);
            } else {
              this.$router.replace(`/order/detail?orderId=${this.orderId}`);
            }
          } else {
            this.payDetail = res.data;
          }
        }
      })
    },
    handlerClick(type) {
      let url = ''
      if (type === 1) {
        url = '/index';
      } else {
        if (this.isSuccess) {
          url = '/order/list';
        } else {
          url = '/index';
        }
      }
      this.$router.replace(url);
    }
  }
}
</script>

<style lang="less" scoped>
.payment-result {
  padding: 250px 30px 300px 30px;
  box-sizing: border-box;
  min-height: 100vh;
  background: #ffffff;

  &__icon {
    width: 120px;
    height: 120px;
    margin: 0 auto;

    &.success {
      background: url('../../assets/img/payment/success.png') center no-repeat;
      background-size: 100% 100%;
    }

    &.failed {
      background: url('../../assets/img/payment/failed.png') center no-repeat;
      background-size: 100% 100%;
    }

    &.timeout {
      background: url('../../assets/img/payment/timeout.png') center no-repeat;
      background-size: 100% 100%;
    }
  }

  &__title {
    margin-top: 40px;
    font-size: 42px;
    color: var(--text-color-black);
    line-height: 48px;
    text-align: center;
    font-weight: 500;
  }

  &__title-sub {
    margin-top: 20px;
    font-size: 26px;
    color: var(--text-color-gray);
    line-height: 32px;
    text-align: center;
  }

  &__info {
    margin-top: 40px;
    background: #F6FBFF;
    border-radius: 12px;
    padding: 30px;
    box-sizing: border-box;
  }

  &__info-title {
    font-size: 42px;
    line-height: 48px;
    font-weight: 500;
  }

  &__info-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .l {
      font-size: 26px;
      color: var(--text-color-gray);
      line-height: 37px;
    }

    .r {
      font-size: 26px;
      line-height: 31px;
    }

    .org {
      font-size: 32px;
      color: var(--red-color);
      line-height: 37px;
      font-weight: 500;
    }
  }

  &__footer {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 30px 30px 50px 30px;

    .bt-white {
      background: var(--white-color);
      border: 1px solid var(--border-color-base);
      color: var(--primary-color);
    }
  }
}
</style>
